var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    className: "app-icon app-icon--normal",
    "data-identify-element": 767,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.7 16.5c-8.5 0-13.6 6.6-13.6 12.5 0 5.8 4.3 9.2 10.2 9.2 5.9 0 13.8-4.5 13.8-12.2 0-7.7-7.4-9.5-10.4-9.5m8.9 78.6c.8 1.1.7 2.7-.4 3.6-8.7 7.3-18.9 12.6-24.8 14-6.4 1.5-11.4 1-11.9-5.9s8-36.3 8.6-39.5c.5-2.6-5.7.1-10.7 2.6-1.5.7-3.3.1-4-1.3-.6-1.2-.2-2.6.9-3.4 8.8-6.2 19.7-12 28.9-14.4 5.3-1.3 8.4.3 8.6 6.4.2 6.1-8.6 34.1-9.3 37.9-1 5.5 5.7 2.1 10.5-.8 1.1-.6 2.7-.3 3.6.8",
    "data-identify-element": 768
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.88d5529ae10fd4c8f5f74c3c1feb9481.svg";
export { ForwardRef as ReactComponent };